export function arrayKey (arr) {
	let res = []
	for (let key in arr) {
		res.push(key)
	}
	return res
}

export function removeAttributeId (arr) {
	let resArray = arr

	function removeId (resArray) {
		for (let keyAttr in resArray) {
			if (typeof resArray[keyAttr].attributes === 'object' && resArray[keyAttr].attributes !== null) {
				if (resArray[keyAttr].id) {
					delete resArray[keyAttr].id
				}
				removeId(resArray[keyAttr].attributes)
			} else {
				if (resArray[keyAttr].id) {
					delete resArray[keyAttr].id
				}
			}
		}
	}

	removeId(resArray)
	return resArray
}

export let countColumns = function () {
	let screenWidth = window.innerWidth
	if (screenWidth >= 1200) {
		return 3
	} else if (screenWidth >= 992) {
		return 3
	} else if (screenWidth >= 768) {
		return 2
	} else {
		return 1
	}
}

export let mapAttrTabs = function (tab, arrRes, itemStructure, lang) {
	tab.forEach(function (value) {
		if (value.type === 'CONTAINER') {
			arrRes.push(mapAttrGroupTabs(value.attributes, 0, itemStructure, lang))
		} else {
			if (value.type !== 'CONTAINER' && itemStructure[value.title.replace(/\./g, '_')].type === 'SL') {
				arrRes.push(Object.values(lang).length)
			} else {
				arrRes.push(1)
			}
		}
	})
}

export let mapAttrGroupTabs = function (arr, l, itemStructure, lang) {

	arr.forEach(function (value) {
		if (value.type === 'CONTAINER') {
			mapAttrGroupTabs(value.attributes, l, itemStructure, lang)
		} else { // учет sl и кол языков
			if (value.type !== 'CONTAINER' && itemStructure[value.title.replace(/\./g, '_')].type === 'SL') {
				l += Object.values(lang).length
			} else {
				l += 1
			}
		}
	})
	return l
}

export let chunkTabAttribute = function (map, tab) {

	let sumArray = []
	let current = Array(countColumns() - 1)

	map.forEach(function (value, i) {
		sumArray.push(value + (i > 0 ? sumArray[i - 1] : 0))
	})

	let getSum = function (i, j) {
		return i >= 0 ? sumArray[j] - sumArray[i] : sumArray[j]
	}

	let getScore = function (current) {
		let left = -1
		let res = []
		current.forEach(function (value, i) {
			res.push(getSum(left, value))
			left = value
		})

		res.push(getSum(left, sumArray.length - 1))

		let sum = 0
		for (let i = 1; i < res.length; i++) {
			sum += Math.abs(res[i] - res[i - 1])
		}

		sum += Math.abs(res[res.length - 1] - res[0])

		return sum
	}

	let des = function (index, maxIndex, current, best) {
		if (index === current.length) {
			let score = getScore(current)
			if (score <= best.val) {
				return {
					val: score,
					des: current.slice()
				}
			}

			return best
		}

		for (let i = maxIndex; i < sumArray.length; i++) {
			current[index] = i
			let inner = des(index + 1, i + 1, current, best)
			if (inner.val <= best.val) {
				best = inner
			}
		}

		return best
	}

	let best = des(0, 0, current, {
		val: Number.MAX_SAFE_INTEGER || Number.MAX_VALUE,
		des: []
	})

	let res = []
	let bestDes = best.des
	bestDes.unshift(-1)
	bestDes.push(tab.length - 1)

	for (let i = 1; i < bestDes.length; i++) {
		res.push(tab.slice(bestDes[i - 1] + 1, bestDes[i] + 1))
	}

	return res

}
